/**
 * Created by sivanh on 12/12/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userEditMaxConversationsAccountView.tmpl");
    var Bubble = require("ui/bubble/Bubble");

    var UserEditMaxConversationsAccountView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        UserEditMaxConversationsAccountView = Marionette.ItemView.extend({
            template: template,
            className: "max-conv-account-settings-container",
            ui: {
                maxConversationAccountCurrentValue: ".account-settings-current",
                maxConversationsIcon: ".account-settings-bubble-icon"
            },
            uiComponents: {},
            events: {
                "mouseenter @ui.maxConversationsIcon": "_showMaxConversationsBubble",
                "mouseleave @ui.maxConversationsIcon": "_closeMaxConversationsBubble"
            },
            initialize: function (options) {
                this.maxCoversationSettings = options.maxConversationsSettings;
            },

            onRender: function() {
                var currentValue = LE.translator.translate({
                    key: "LEUserManagement.userEdit.maxConversations.accountSettings.current",
                    args: [this.maxCoversationSettings]
                });
                this.ui.maxConversationAccountCurrentValue.text(currentValue);
            },

            onClose: function() {
                LEUserManagement.logger.debug("onClose", "AccountSettingsMaxConversationsView:onClose");
            },

            _showMaxConversationsBubble: function(){
                this._closeMaxConversationsBubble(null, true);
                this.uiComponents.host$.createAndRender("maxConversationsBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.maxConversationsIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate("LEUserManagement.userEdit.maxConversations.accountSettings.tooltip")
                    }
                });
            },

            _closeMaxConversationsBubble: function(event, force){
                 if (this.uiComponents.maxConversationsBubble) {
                    this.uiComponents.maxConversationsBubble.close(force);
                }
            }

        });
    });
    return UserEditMaxConversationsAccountView;
});
